var Giant = Giant || {};

;(function($, window, document, undefined) {

    // HELPERS

    var special = {
        'a': /[àáâãäåăą]/g,
        'A': /[ÀÁÂÃÄÅĂĄ]/g,
        'c': /[ćčç]/g,
        'C': /[ĆČÇ]/g,
        'd': /[ďđ]/g,
        'D': /[ĎÐ]/g,
        'e': /[èéêëěę]/g,
        'E': /[ÈÉÊËĚĘ]/g,
        'g': /[ğ]/g,
        'G': /[Ğ]/g,
        'i': /[ìíîï]/g,
        'I': /[ÌÍÎÏ]/g,
        'l': /[ĺľł]/g,
        'L': /[ĹĽŁ]/g,
        'n': /[ñňń]/g,
        'N': /[ÑŇŃ]/g,
        'o': /[òóôõöøő]/g,
        'O': /[ÒÓÔÕÖØ]/g,
        'r': /[řŕ]/g,
        'R': /[ŘŔ]/g,
        's': /[ššş]/g,
        'S': /[ŠŞŚ]/g,
        't': /[ťţ]/g,
        'T': /[ŤŢ]/g,
        'u': /[ùúûůüµ]/g,
        'U': /[ÙÚÛŮÜ]/g,
        'y': /[ÿý]/g,
        'Y': /[ŸÝ]/g,
        'z': /[žźż]/g,
        'Z': /[ŽŹŻ]/g,
        'th': /[þ]/g,
        'TH': /[Þ]/g,
        'dh': /[ð]/g,
        'DH': /[Ð]/g,
        'ss': /[ß]/g,
        'oe': /[œ]/g,
        'OE': /[Œ]/g,
        'ae': /[æ]/g,
        'AE': /[Æ]/g
    }

    var walk = function(string, replacements){
        var result = string, key;
        for (key in replacements) result = result.replace(replacements[key], key);
        return result;
    };

    var hyphenate = function(str) {
        return String(str).replace(/[A-Z]/g, function(match){
            return ('-' + match.charAt(0).toLowerCase());
        });
    };

    var standardize = function(str) {
        return walk(str, special);
    };

    var toUrl = function(str) {
        str = standardize(str).toLowerCase();
        str = hyphenate(str);
        str = str.replace(/(&nbsp;)+/g, " ").replace(/[\W]+/g, " ").replace(/[\s]+/g, "-").replace(/^[-]/g, "").replace(/-$/g, "");
        return str;
    };

    // PLUGIN DEFINITION

    var pluginName = 'url',
        $window = $(window),
        defaults = {
            prefix: '', // element id prefix
            mask: '', //
            validate: false,
            delay: 400,
            editable: true
        };

    function AutoUrl(element, options) {
        this.scope = element;
        this.$scope = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    AutoUrl.prototype = {

        editable: true,
        items: {},
        timer: null,
        parts: [],

        init: function() {
            var self = this;

            this.parts = this.options.mask.match(/[\w]+/gi);
            this.items = {};
            this.timer = null;
            this.editable = true;

            if (!this.options.editable && this.scope.value.trim() != ''){
                this.editable = false;
            }

            this.attach();

            return this;
        },

        attach: function() {
            var self = this;
            this.$scope
                .on('focus.autoUrl', function() {
                    self.editable = false;
                })
                .on('keyup.autoUrl', self.generate.bind(self));

            this.parts.forEach(function(part) {
                var $element = $('#' + self.options.prefix + part);

                switch ($element.prop('tagName')) {
                    case 'select':
                        $element.on('change.autoUrl', self.generate.bind(self));
                    break;
                    default:
                        $element.on('keyup', self.generate.bind(self));
                }
                self.items[part] = $element;
            });

            return this;
        },

        detach: function() {
            this.$scope.off('.autoUrl');
            Object.keys(self.items).forEach(function(key) {
                self.items[key].off('.autoUrl');
            });

            return this;
        },

        generate: function() {
            var self = this;

            if (this.editable){
                var rawUrl = this.options.mask;
                Object.keys(this.items).forEach(function(key) {
                    rawUrl = rawUrl.replace('{' + key + '}', self.items[key].val());
                });
                this.scope.value = toUrl(rawUrl);
            }

            if (this.options.validate){
                this.validate();
            }

            return this;
        },

        validate: function() {
            clearTimeout(this.timer);
            this.timer = setTimeout(this.request.bind(this), this.options.delay);
            return this;
        },

        request: function() {
            var self = this;
            $.ajax({
                url: self.options.validate,
                dataType: 'json',
                beforeSend: function() {
                    self.$scope.addClass('working');
                },
                success: function(response) {
                    if (response && 'url' in response) {
                        if (self.scope.value !== response.url) {
                            self.scope.value = response.url;
                        }
                    }
                },
                complete: function() {
                    self.$scope.removeClass('working');
                }

            });
        }
    };

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin-' + pluginName)) {

                // parse data-options
                var data = $(this).data(),
                    options = {},
                    settings = '';

                if (pluginName in data) {
                    settings = data[pluginName];
                    // pass options
                    if ($.type(settings) === 'object') {
                        options = settings;
                    }

                    // parse shortcut and create options
                    if ($.type(settings) === 'string' && settings !== '') {
                        options.mask = settings;
                    }
                }

                $.each(defaults, function(key, value) {
                    var option = pluginName + key.substr(0,1).toUpperCase() + key.substr(1);

                    if (option in data) {
                        options[key] = data[option];
                    }
                });

                if (!('prefix' in options)) {
                    options.prefix = $(this).closest('form').attr('id') + '-';
                }

                $.data(this, 'plugin-' + pluginName, new AutoUrl(this, options));
            }
        });
    };

    $.fn[pluginName].defaults = defaults;

    // listen to change event and init self
    $(document).on('change:dom', function(event) {
        $('[data-url]', event.target).url();
    });
    $('[data-url]').url();

    Giant.AutoUrl = AutoUrl;

})(jQuery, window, document);